import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { HippoContentService } from '../../services/hippo-content.service';
import { ActionTypes, GetLabels } from '../actions/content.action';
import { ContentState } from '../state/content.state';

@Injectable()
export class ContentEffects {
    getLabels$ = createEffect(() => 
        this.action$
            .pipe(
                ofType<GetLabels>(ActionTypes.GetLabels),
                withLatestFrom(this.store.select(state => state.labels)),
                mergeMap(([action, state]) => {
                    if (Object.keys(state).length === 0 || action.payload && action.payload.reload) {
                        return this.hippoContentService.getLabels$().pipe(
                            map(labels => ({type: ActionTypes.GetLabelsComplete, payload: labels}))
                        );
                    } else {
                        return of(state).pipe(
                            map(labels => ({type: ActionTypes.GetLabelsComplete, payload: labels})
                            ));
                    }
                })
            )
    );
    constructor(
        private action$: Actions,
        private store: Store<ContentState>,
        private hippoContentService: HippoContentService,
    ) {}

}
